/**
 * La signature du client sur une offre acceptée : son tracé, son nom, le jour
 * et l'heure. L'écran de l'offre et son document (PDF compris) la montrent
 * sous « Bon pour accord » ; le patron voit ainsi qui a signé, et quand.
 */

/**
 * L'heure d'un instant, à l'heure suisse : « 14:32 ».
 *
 * @param {string} [instant] instant ISO rendu par le serveur
 * @returns {string} l'heure, ou une chaîne vide
 */
export function heureSuisse(instant) {
  if (!instant) return '';
  const d = new Date(instant);
  if (Number.isNaN(d.getTime())) return '';
  try {
    return new Intl.DateTimeFormat('fr-CH', {
      hour: '2-digit',
      minute: '2-digit',
      timeZone: 'Europe/Zurich',
    }).format(d);
  } catch (e) {
    return String(d.getHours()).padStart(2, '0') + ':' + String(d.getMinutes()).padStart(2, '0');
  }
}

/**
 * La signature d'une offre, telle que l'écran la lit.
 *
 * @param {object} [d] offre, au format de l'écran
 * @returns {{trace: string, nom: string, date: string, heure: string}|null}
 *   la signature, ou rien si l'offre n'est pas acceptée ou n'en porte pas
 */
export function signatureDuClient(d) {
  if (!d || d.statut !== 'Accepté') return null;
  const trace = typeof d.sig === 'string' && /^M[\d.\s]/.test(d.sig.trim()) ? d.sig.trim() : '';
  const nom = String(d.signePar || '').trim();
  if (!trace && !nom) return null;
  return { trace, nom, date: d.signDate || '', heure: heureSuisse(d.signeLe) };
}
